import { addTransportConditionCheckedItem, resetTransportFilterCheckedItems, setTransportConditionSelectedDatetime, setTransportSearchValue, setTransportSelectedItem } from 'app/actions/map';
import * as actions from 'app/actions/notification';
import { NOTIFICATION_DELETE_ALL_QUEUE } from 'app/utils/constants';
import { batch } from 'react-redux';

// ПО промежуточного слоя использует действия для взаимодействия
// с уведомлениями и остальными сообщениями приложения.
export const notificationMiddleware = function () {
    const queue = [];

    // Создание уникального идентификатора для очереди уведомлений.
    const createQueueId = (length) => {
        const chars = [...'0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'];
        return [...Array(length)].map(() => chars[(Math.random() * chars.length) | 0]).join('');
    };

    // Обработчик события добавления уведомления.
    const addEvent = (dispatch, payload) => {
        const { text, color, timeout = config.snackbarTimeout, action = null, isTransportEvent = false } = payload;

        // Создадим уникальный ключ для управления уведомлением.
        const id = createQueueId(16);

        // Запустить таймер на удаление уведомления из очереди.
        const clearQueue = () => {
            const timeoutId = setTimeout(() => {
                dispatch(actions.deleteItem(id));

                // Проверим очередь уведомлений.
                checkQueue(dispatch);
            }, timeout);

            return timeoutId;
        };

        const timeoutId = timeout > 0 ? clearQueue() : timeout;

        // Отправка действий для создания уведомления в Redux.
        dispatch(
            actions.addItem({
                id,
                timeoutId,
                text,
                color,
                action,
                isTransportEvent,
            })
        );
    };

    // Обработчик события удаление уведомления.
    const deleteEvent = (dispatch, value) => {
        // Удалить таймер на удаление уведомления.
        if (value.timeout > 0) {
            clearTimeout(value.timeout);
        }

        // Отправка действия на удаление уведомления из Redux.
        dispatch(actions.deleteItem(value.id));

        // Проверим очередь уведомлений.
        checkQueue(dispatch);
    };
    // Обработчик события удаление всех уведомлений.
    const deleteAllEvents = (dispatch, values) => {
        // Отправка действия на удаление уведомления из Redux.
        dispatch(actions.deleteAllItems());
        for (let value of values) {
            // Удалить таймер на удаление уведомления.
            if (value.timeout > 0) {
                clearTimeout(value.timeout);
            }
        }
        // Проверим очередь уведомлений.
        checkQueue(dispatch);
    };

    // Обработчик события проверки очереди уведомлений.
    const checkQueue = (dispatch) => {
        if (queue.length) {
            // Отправим действие на добавление уведомления.
            addEvent(dispatch, queue[queue.length - 1]);

            // Удалим уведомление из очереди.
            queue.splice(queue.length - 1, 1);
        }
    };

    return (store) => (next) => (action) => {
        switch (action.type) {
            case 'NOTIFICATION_ADD_QUEUE': {
                const { items } = store.getState().notification;

                // Если количество уведомлений на экране больше заданного лимита.
                if (items.length >= config.snackbarLimit) {
                    queue.unshift(action.payload);
                    break;
                }

                addEvent(store.dispatch, action.payload);
                break;
            }
            case 'NOTIFICATION_ADD_EVENT_QUEUE': {
                const { permissions } = store.getState().session.session;

                // Заменить данное условие при влитии 411 задачи, где изменено разграничение прав по ролям.
                if (!permissions.includes('drain')) {
                    return;
                }
                const { datetime, geofence_id, geofence_name, transport_id } = action.payload;
                const { ref: mapRef, transportItems } = store.getState().map;
                const { id, number } = transportItems.find((item) => item.id === transport_id) || {};

                if (id) {
                    store.dispatch({
                        type: 'NOTIFICATION_ADD_QUEUE',
                        payload: {
                            text: config.mapTransportEventMessages['1']
                                .replace('$datetime', moment.utc(datetime).local().format('DD.MM.YYYY HH:mm:ss'))
                                .replace('$name', number)
                                .replace('$geofence', geofence_id ? geofence_name : '')
                                .replace('в геозоне «»', ''),
                            action: () => {
                                const transportItem = store.getState().map.transportItems.find((item) => item.id === transport_id);
                                const checkedType = store.getState().map.transportConditionFilterCheckedType;
                                batch(() => {
                                    // Сбрасываем фильтры и поиск
                                    if (checkedType === 'filter') {
                                        store.dispatch(addTransportConditionCheckedItem(['event_id:1']));
                                    }
                                    store.dispatch(setTransportSearchValue(''));
                                    store.dispatch(resetTransportFilterCheckedItems());

                                    // Устанавливаем выбранный транспорт
                                    store.dispatch(setTransportSelectedItem(transportItem));

                                    // Устанавливаем конкретное время события
                                    store.dispatch(setTransportConditionSelectedDatetime(moment.utc(datetime).local().format('YYYY-MM-DD HH:mm:ss')));
                                });

                                if (transportItem.conditions[transportItem.conditions.length - 1].data.geodata !== 'ERR') {
                                    mapRef.current.handleClosePopup();
                                    mapRef.current.handleFlyTo([transportItem.conditions[transportItem.conditions.length - 1].data.lat, transportItem.conditions[transportItem.conditions.length - 1].data.lon], null);
                                }

                                deleteEvent(store.dispatch, action.payload);
                            },
                            color: 'warning',
                            timeout: 0,
                            isTransportEvent: true,
                        },
                    });
                }
                break;
            }
            case 'NOTIFICATION_DELETE_QUEUE': {
                deleteEvent(store.dispatch, action.payload);
                break;
            }
            case NOTIFICATION_DELETE_ALL_QUEUE: {
                deleteAllEvents(store.dispatch, action.payload);
                break;
            }
            default:
                return next(action);
        }
    };
};

export default notificationMiddleware;
